import React, { useState } from "react";
import PropTypes from "prop-types";
import { Checkbox, Link } from "@material-ui/core";

import { useHistory } from "react-router-dom";
import {
  TableBody as MuiTableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";

import TableFilter from "@Components/Table/TableFilter";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";

const TableBody = ({
  classes,
  filters,
  updatedRecords,
  updatedHeadCells,
  setLoading,
  checkBox,
  setChecked,
  grandTotalEnable,
  setEmployeeId,
  editPermission,
  viewDetailsPermission,
}) => {
  const linkUrlName = editPermission ? "/edit/" : viewDetailsPermission ? "/view-details/" : "";

  const history = useHistory();
  const [currentState, setCurrentState] = useState(false);
  const handleCheckBox = (e, id, employee_id) => {
    setChecked(id);
    if (setEmployeeId && setEmployeeId != undefined) {
      setEmployeeId(employee_id);
    }
    setCurrentState(!currentState);
  };
  let newRecords;
  const displayCheckBox = setChecked || setChecked !== undefined;

  if (displayCheckBox) {
    newRecords = updatedRecords.map((record, index) => {
      record.check = (
        <Checkbox
          checkedIcon={<CheckBoxOutlinedIcon />}
          size="small"
          color="default"
          key={index}
          checked={checkBox.includes(record.id) || checkBox.includes("all")}
          onChange={(e) => handleCheckBox(e, record.id, record.employee_id)}
          className={classes.checkBox}
        />
      );
      return record;
    });
  } else {
    newRecords = grandTotalEnable ? updatedRecords.slice(1) : updatedRecords;
  }
  const firstFieldName = displayCheckBox
    ? updatedHeadCells[1].id
    : updatedHeadCells[0].id;

  return (
    <MuiTableBody>
      {filters ? (
        <TableFilter
          filters={filters}
          setLoading={setLoading}
          checkBox={setChecked || setChecked !== undefined}
        />
      ) : null}
      {newRecords.map((record, index) => (

        <TableRow key={index}  >
          {updatedHeadCells.map((headCell) => {
            if (headCell.id === "active_approval_request") {
              return null;
            }
            return headCell["id"] === firstFieldName ? (
              <TableCell key={headCell.id} >
                {linkUrlName ? (
                  <Link
                    style={{
                      textDecoration: "none",
                      fontWeight: "450",
                    }}
                    href={`${history.location.pathname}${linkUrlName}${record.id}`}
                    onClick={() => {
                      history.push(
                        `${history.location.pathname}${linkUrlName}${record.id}`
                      );
                    }}
                  >
                    {record[headCell["id"]]}
                  </Link>
                ) : (
                  record[headCell["id"]]
                )}

              </TableCell>

            ) : (
              <TableCell
                key={headCell.id}
                style={headCell.id === "title" ? { width: '500px' } : {}}
                className={
                  headCell.id === "check" ? classes.checkBoxTableCell : null
                }
                width={headCell.id === "check" ? 50 : "auto"}
              >
                {/*if there is an array in the table body this condition will make that array a list*/}
                {headCell.id === "remarks" && Array.isArray(record[headCell.id]) ? (
                  <ul>
                    {record[headCell.id].map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                ) : headCell.id === "banner_type" ? (
                  record[headCell.id] === "PB" ? "Policy Banner" : record[headCell.id] === "IAB" ? "In-App Banner" : record[headCell.id]
                ) : ["not_agreed_percent", "agreed_percent", "not_responded_percent"].includes(headCell.id) ? (
                  parseFloat(record[headCell.id]) === 0 ? "0.00%" : `${record[headCell.id]}%`
                ) : (
                  record[headCell.id]
                )}






              </TableCell>

            );
          })}

        </TableRow>



      ))}
      {grandTotalEnable ? (
        <TableRow>
          {Object.keys(updatedRecords.find((item) => item.id === "total") || {}).map((key) => (
            <TableCell key={key}>
              <strong>
                {["net_agreed_percent", "net_not_responded_percent", "net_not_agreed_percent"].includes(key) ? (
                  parseFloat(updatedRecords.find((item) => item.id === "total")[key]) === 0
                    ? "0.00%"
                    : `${updatedRecords.find((item) => item.id === "total")[key]}%`
                ) : (
                  updatedRecords.find((item) => item.id === "total")[key]
                )}
              </strong>
            </TableCell>
          ))}
        </TableRow>
      ) : null}

    </MuiTableBody>
  );
};

TableBody.propTypes = {
  classes: PropTypes.object,
  filters: PropTypes.array,
  updatedRecords: PropTypes.array,
  updatedHeadCells: PropTypes.array,
  setLoading: PropTypes.func,
  checkBox: PropTypes.array,
  grandTotalEnable: PropTypes.bool,
  setChecked: PropTypes.func,
  setEmployeeId: PropTypes.func,
  linkUrlName: PropTypes.string,
  viewDetailsPermission: PropTypes.bool,
  editPermission: PropTypes.bool,

};

export default TableBody;
